import type React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

// Skeleton for just the leaderboard table (used in Suspense inside the page)
const LeaderboardSkeleton: React.FC = () => (
  <div className="rounded-lg border">
    {/* Table Header */}
    <div className="border-b-2 bg-muted/40 p-4">
      <div className="grid grid-cols-7 gap-4">
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-4 w-16" />
        <Skeleton className="h-4 w-20" />
        <Skeleton className="h-4 w-20" />
        <Skeleton className="h-4 w-16" />
        <Skeleton className="h-4 w-16" />
        <Skeleton className="h-4 w-24" />
      </div>
    </div>
    {/* Table Rows */}
    {Array.from({ length: 8 }).map((_, index) => (
      <div key={index} className="border-b last:border-b-0 p-4">
        <div className="grid grid-cols-7 gap-4">
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-4 w-8" />
          <Skeleton className="h-4 w-8" />
          <Skeleton className="h-4 w-8" />
          <Skeleton className="h-4 w-12" />
          <Skeleton className="h-4 w-16" />
        </div>
      </div>
    ))}
  </div>
)

// Full page skeleton (used for route pending and auth loading)
const ActivityPageSkeleton: React.FC = () => (
  <div className="flex flex-col gap-6 p-6 max-w-full overflow-x-auto">
    {/* Activity Stats - 5 column grid */}
    <div className="grid gap-4 grid-cols-2 md:grid-cols-3 xl:grid-cols-5">
      {Array.from({ length: 5 }).map((_, index) => (
        <div key={index} className="border rounded-lg">
          <div className="flex flex-row items-center justify-between space-y-0 pb-2 p-4">
            <Skeleton className="h-4 w-16" />
            <Skeleton className="h-4 w-4" />
          </div>
          <div className="px-4 pb-4">
            <Skeleton className="h-8 w-12 mb-1" />
            <Skeleton className="h-3 w-20" />
          </div>
        </div>
      ))}
    </div>

    {/* Leaderboard Section */}
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <Skeleton className="h-6 w-56" />
        <Skeleton className="h-6 w-40" />
      </div>
      <LeaderboardSkeleton />
    </div>
  </div>
)

export { ActivityPageSkeleton, LeaderboardSkeleton }
